import "./index.less";
import template from "./index.html";
import veslLogo from "../../../images/vesl_logo.svg";

function controller(
	$state,
	openIdService,
	$logger
) {
	const ctrl = this;
	ctrl.veslLogo = veslLogo;

	ctrl.$onInit = () => {
		const fromRoute = openIdService.getFromRoute();

		openIdService.completeSigninRedirect().then(() => {
			if(fromRoute) {
				$state.transitionTo(fromRoute.name, fromRoute.params, { location: "replace", reload: "authenticated.dashboard" });
			}
			else {
				$state.transitionTo("authenticated.dashboard", {}, { location: "replace", reload: "authenticated.dashboard" });
			}
		}, (error) => {
			$logger.exception(error, "OpenID redirect callback failed");
			$state.transitionTo("unauthenticated.failed", {
				system: true,
				errorMsg: openIdService.getAuthenticationFailureMessage(error)
			}, { location: "replace" });
		});
	};
}

export default angular
	.module("vesl.screens.public.oauth-login", [])
	.component("oauthLogin", {
		template,
		controller
	}).name;
